import { useState, useEffect } from "react";

const navItems = [
  { label: "首页", href: "#hero" },
  { label: "手机看剧", href: "#app" },
  { label: "每日更新", href: "#updates" },
  { label: "精选剧集", href: "#cards" },
  { label: "热门话题", href: "#topics" },
  { label: "关于我们", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-[68px] max-w-[1400px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#hero");
            }}
            className="flex items-center gap-2 shrink-0"
          >
            <span
              className={`text-2xl font-bold font-heading tracking-tight whitespace-nowrap transition-colors ${
                scrolled ? "text-primary-500" : "text-white"
              }`}
            >
              6080影视
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? item.label === "首页"
                      ? "text-primary-500"
                      : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50/60"
                    : item.label === "首页"
                      ? "text-primary-300"
                      : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
              scrolled
                ? "text-foreground-700 hover:bg-background-100"
                : "text-white hover:bg-white/10"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  item.label === "首页"
                    ? "text-primary-500 bg-primary-50/60"
                    : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50/60"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}